import Image from 'next/image';
import classNames from 'classnames';

import { SectionTitle, TextBlock, NumList } from '@/ui/index';

import styles from './ContentList.module.scss';

const InfoTable = ({ data, className }) => {
  const renderListItem = (item, index) => {
    return <li key={index}>{item}</li>;
  };

  const renderLinks = (item, index) => {
    const renderIsType = (() => {
      if (item.type === 'phone') {
        return (
          <a
            title={item.text}
            aria-label={item.text}
            href={`tel:${item.src}`}
            target='_blank'
            rel='nofollow noopener noreferrer'
          >
            {item.text}
          </a>
        );
      }

      if (item.type === 'email') {
        return (
          <a
            title={item.text}
            aria-label={item.text}
            href={`mailto:${item.src}`}
            target='_blank'
            rel='nofollow noopener noreferrer'
          >
            {item.text}
          </a>
        );
      }

      return (
        <a title={item.text} aria-label={item.text} href={item.src}>
          {item.text}
        </a>
      );
    })();

    return <li key={index}>{renderIsType}</li>;
  };

  return (
    <section className={classNames(styles['content-list'], className)}>
      {data?.title && (
        <SectionTitle
          titleModify={classNames(
            styles['content-list__title'],
            'title--large',
          )}
        >
          {data.title}
        </SectionTitle>
      )}
      <div className={styles['content-list__grid']}>
        <div className={styles['content-list__inner']}>
          {data?.description && (
            <TextBlock
              className={classNames([
                styles['content-list__text'],
                'text--medium',
                'text--shadow-black',
              ])}
              isHtml
            >
              {data.description}
            </TextBlock>
          )}
          {data?.numList && (
            <NumList className={styles['content-list__values']}>
              {data.numList.map(renderListItem)}
            </NumList>
          )}
          {data?.linkBlock && (
            <div className={styles.links}>
              {data?.linkBlock?.title && (
                <strong className={styles.links__title}>
                  {data.linkBlock.title}
                </strong>
              )}
              {data?.linkBlock?.links?.length && (
                <ul className={styles.links__list}>
                  {data.linkBlock.links.map(renderLinks)}
                </ul>
              )}
            </div>
          )}
        </div>
        {data?.image && (
          <div className={styles['img-block']}>
            <Image
              className={styles['img-block__elem']}
              src={data.image}
              alt={data?.title}
              title={data?.title}
              loading='lazy'
              layout='fill'
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default InfoTable;
